import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './assets/styles/design-tokens.css'
import './assets/styles/base.css'
import App from './App.vue'
import router from './router'
import { initPageScale } from './utils/pageScale'

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual'
}

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

app.mount('#app')
initPageScale()
